import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { Tag, TagFormValues } from "../models/tag"
import { tagApi } from "../services/tagApi"

const BASE_KEY = "tags"

export function useCreateTag() {
  const queryClient = useQueryClient()
  return useMutation<Tag, Error, TagFormValues>({
    mutationFn: (values) => tagApi.create(values) as Promise<Tag>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useUpdateTag() {
  const queryClient = useQueryClient()
  return useMutation<
    Tag,
    Error,
    { id: number; values: Partial<TagFormValues> }
  >({
    mutationFn: ({ id, values }) => tagApi.update(id, values) as Promise<Tag>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useDeleteTag() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, number>({
    mutationFn: (id) => tagApi.delete(id) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}
